import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import PropTypes from 'prop-types'
import { ShippingContainer, ShippingOption, ShippingImageContainer, ShippingText } from './styles'

const ShippingDetails = ({ frame }) => {
  const { shipping, setup, returns } = useStaticQuery(graphql`
    query ShippingIconsQuery {
      shipping: file(relativePath: { eq: "shipping.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      setup: file(relativePath: { eq: "setup.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      returns: file(relativePath: { eq: "returns.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
    }
  `)
  const SHIPPING_INFO = [
    {
      image: setup,
      alt: 'clock',
      text: 'Easy Setup in 10 Minutes or Less',
    },
    {
      image: shipping,
      alt: 'speedy shipping truck',
      text: 'Ships in 1-2 Business Days',
    },
    {
      image: returns,
      alt: 'Boxed return',
      text: '4-Month Free Returns',
    },
  ]

  return (
    <ShippingContainer frame={frame}>
      {SHIPPING_INFO.map((option, i) => (
        <ShippingOption frame={frame} key={i}>
          <ShippingImageContainer truck={option.alt === 'speedy shipping truck'}>
            <GatsbyImage image={option.image.childImageSharp.gatsbyImageData} alt={option.alt} />
          </ShippingImageContainer>
          <ShippingText special={option.alt === 'checkmark' || option.alt === 'pricetag'}>
            {option.text}
          </ShippingText>
        </ShippingOption>
      ))}
    </ShippingContainer>
  )
}

export default ShippingDetails

ShippingDetails.propTypes = {
  frame: PropTypes.bool,
}
